<template>
<card>
    <b-card-header class="border-0">
        <h3 class="mb-0" style="font-size: 18px; font-weight: bold; color: #2c3e50;">
            SENARAI PENJAWAT AWAM {{funcLabel}}
        </h3>
    </b-card-header>

    <!-- <CarianBaharu
      @carianProgram="searchProgram"
      @resetPaging="resetPaging"
    ></CarianBaharu> -->

    <el-table v-loading="loading" class="table-responsive table" header-row-class-name="thead-light" :header-cell-style="{
    background: '#f6f9fc',
    color: '#000',
    fontWeight: 'bold',
    fontSize: '16px'
  }" :cell-style="{
    fontWeight: 600,
    color: '#000',
    fontSize: '14px'
  }" :data="SenaraiPenjawatAwam" style="width: 100%">
        <el-table-column align="center" type="index" :index="indexMethod" width="70px" />
        <el-table-column label="NO KAD PENGENALAN" prop="NoKP" min-width="250px" />
        <el-table-column label="NAMA" prop="CONm" min-width="250px" />
        <el-table-column label="NO PERMOHONAN" prop="NoMohon" min-width="250px" />
        <el-table-column label="AGENSI" prop="Agensi" min-width="250px" />
        <el-table-column label="PEGAWAI PENGIRA" prop="PegPengira" min-width="250px" />

        <el-table-column label="Tindakan" min-width="150px" align="right" fixed="right">
            <template slot-scope="scope">
                <base-button size="xl" icon type="primary" class="mb-2" @click="showVal((scope.row))">
                    <span class="btn-inner--icon"></span>
                    <span class="btn-inner--text">Lihat</span>
                </base-button>
                <base-button v-if="kiraan === 2" size="xl" icon type="warning" class="mb-2" @click="buatTindakan(scope.row)">
                    <span class="btn-inner--icon"></span>
                    <span class="btn-inner--text">Tindakan</span>
                </base-button>
            </template>
        </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
        <el-pagination background layout="prev, pager, next" :total="ClientPaging.totalRow" :page-size="ClientPaging.totalRowPerPaging" @current-change="pageChanged">
        </el-pagination>
    </b-card-footer>
    <!--Form modal-->
    <modal :show.sync="modals.list" size="xl" body-classes="p-1">
        <template slot="header">
            <h3 class="mb-0">DETAIL PEGAWAI</h3>
        </template>
        <template>
            <MDListVue :listRow="listRow" @batal="batal"></MDListVue>
        </template>
        <template slot="footer"> &nbsp; </template>
    </modal>
</card>
</template>

<script>
import {
    Table,
    TableColumn,
    Pagination
} from "element-ui";
import GetsalaryService from "@/services/salaryService.js";
import Store from "@/store";
import BaseButton from "@/components/BaseButton.vue";
import MDListVue from "@/views/Skg/Pentadbir_BGE/MDList.vue";

export default {
    props: {
        kiraan: {
            type: Number,
            default: 0
        }
    },
    name: "DASHBOARD",
    components: {
        BaseButton,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Pagination.name]: Pagination,
        MDListVue

    },
    data() {
        return {
            SenaraiPenjawatAwam: [{
                    CONm: "SHUKRI AMIN",
                    NoKP: "2000101010101",
                    NoMohon: "M-001",
                    Agensi: "KPM",
                    PegPengira: "AKMAL",
                    Kategori: "KUMPULAN PELAKSANA",
                },
                {
                    CONm: "SAHDELI",
                    NoKP: "200301010101",
                    NoMohon: "K-002",
                    Agensi: "KPM",
                    PegPengira: "SOFIAN",
                    Kategori: "FASI BGE",
                }
            ],
            currentPage: 1,
            ClientPaging: {
                pagingType: 2,
                totalRow: 0,
                totalRowPerPaging: 0,
                totalPage: 0,
                memTableName: null,
                lastPage: 0,
            },
            loading: false,
            label: "",
            modals: {
                list: false,
            },
            listRow: {},
        };
    },

    methods: {
        pageChanged(val) {
            this.currentPage = val;
            this.queryPageData(val);
        },
        showVal(scope) {
            console.log("scope", scope)
            this.modals.list = true;
            this.listRow = scope;
        },
        batal() {
            this.modals.list = false;
        },
        buatTindakan(scope) {
console.log("scope", scope)
            this.$router.push({
                name: 'KEMASKINI MAKLUMAT PEMOHON',
                params: {
                    ICNo: '670131135590',
                    coid: '12',
                }
            })
        },

        queryPageData(currentPage) {
            this.loading = false;

            let search = {
                currentPage: currentPage,
            };

            // GetsalaryService.getSenaraiPenjawatAwamInfo(search)
            //   .then((resp) => {
            //    this.ClientPaging = resp.data;
            //       console.log("pagingInfo: ", resp.data);
            //   })
            //    .then(() => {
            //        GetsalaryService.getSenaraiPenjawatAwamdata(
            //           search
            //        ).then((resp) => {
            //            this.SenaraiPenjawatAwam = resp.data;
            //console.log("pagingData: ", SenaraiPenjawatAwam);
            //       });
            //    });
        },

        indexMethod(index) {
            return (
                index + 1 + (this.currentPage - 1) * this.ClientPaging.totalRowPerPaging
            );
        },
    },

    created() {
        this.queryPageData(1);

        console.log("kiraan", this.kiraan);

    },
    computed: {
        funcLabel() {
            if (this.kiraan === 1) {
                return "DALAM PROSES";
            } else if (this.kiraan === 2) {
                return "DALAM TINDAKAN";
            } else if (this.kiraan === 3) {
                return "SELESAI";
            } else {
                return "";
            }
        }
    }
};
</script>

<style scoped>
.table-responsive .el-table__header th {
    font-size: 16px;
    font-weight: bold;
    background-color: #f6f9fc;
    color: #000;
}

.table-responsive .el-table__body td {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.b-card-header h3 {
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
    /* biru gelap profesional */
}
</style>
